import React from 'react';
import { IconDisplay } from '../lib/payment_method_icons';

export function PaymentMethodIcons({ icons }: { icons: IconDisplay[] }) {
  return (
    <>
      {icons.map(icon => (
        <img className="payment-icon" src={icon.source} alt={icon.text} key={`${icon.text}`} />
      ))}
    </>
  );
}
